export default __webpack_public_path__ + "static/media/skip-img.8ad97770.svg";